import { ABState } from 'mk2/containers/AB/AB.reducers';
import { AppState } from 'mk2/reducers';
import { LoadingState } from 'mk2/reducers/loadingState';

export const getABVariant = (state: AppState, name: string): ABState => {
    return state.containers.global.ab[name] || {
        loadingState: LoadingState.INIT,
        variant: null,
    };
};
